const skin = {
	topLayout:"space",
	//bar in accordion
	barHeight:46,			// !!!Set the same in skin.less!!!
	tabbarHeight: 46,
	rowHeight:34,
	toolbarHeight:46,
	sidebarTitleHeight:45,
	listItemHeight:34,		// list, grouplist, dataview, etc.
	unitHeaderHeight:20,
	inputHeight: 38,
	buttonHeight: 38,
	inputPadding: 3,
	menuHeight: 34,
	labelTopHeight: 22,
	propertyItemHeight: 28,
	timelineItemHeight:70,

	inputSpacing: 4,
	borderWidth: 1,

	sliderHandleWidth: 14,
	sliderPadding: 10,
	sliderBorder: 1,
	vSliderPadding:15,
	vSliderHeight:100,
	switchHeight:22,
	switchWidth:50,

	//margin - distance between cells
	layoutMargin:{ space:10, wide:10, clean:0, head:4, line:-1, toolbar:8, form:8, accordion: 10  },
	//padding - distance inside cell between cell border and cell content
	layoutPadding:{ space:10, wide:0, clean:0, head:0, line:0, toolbar:3, form:17, accordion: 0  },
	//space between tabs in tabbar
	tabMargin:4,
	tabOffset: 0,
	tabBottomOffset: 6,
	tabTopOffset:1,

	customCheckbox: true,
	customRadio: true,

	popupPadding: 8,
	dataPadding: 10,

	calendarWeekHeaderHeight: 24,
	padding:0,
	accordionType: "accordion",

	optionHeight: 32,
	timelineColor:"#b300b3",

	backColor:"#393939"
};

export default skin;